/* ============================================================
   gwb-triptyque.js — Raccourci « Triptyque » du configurateur
   Cassili-home
   ------------------------------------------------------------
   gwb.js n'est PAS modifié. Interventions, toutes réversibles :

   1. Un tiroir « Triptyque » injecté dans le panneau « 2. Nombre
      d'affiches », au-dessus de Composition.
   2. Le produit bundle est retiré du sélecteur de produits, en
      filtrant la réponse de products.json.
   3. À l'ajout au panier, les trois lignes individuelles sont
      remplacées par la variante du bundle. Le Cart Transform de
      Simple Bundles ré-éclate ensuite en trois lignes côté
      commande — validé par la commande #1006.
   4. Le total affiché est corrigé.
   5. Ajustement des cadres dans la scène, et deux correctifs CSS
      de gwb.css sans rapport avec le triptyque. Voir plus bas.

   Le rendu dans la scène reste assuré par les affiches
   individuelles — image v6 en Poster, v8 en Encadrée
   (gwb.js, getSlotImageForFinish).

   IMPORTANT : ce fichier doit être chargé AVANT gwb.js et SANS
   l'attribut defer, pour que le correctif de fetch soit en place
   quand gwb.js demande products.json.
   ============================================================ */

(function () {
  'use strict';

  var CLE_ETAT = 'cassili_gallery_wall_builder_v4';
  var CLE_ACTIF = 'gwb_triptyque_actif';
  var CLE_ATTENTE = 'gwb_triptyque_attente';

  /* ----------------------------------------------------------
     Catalogue des triptyques
     Pour en ajouter un : dupliquer le bloc, remplacer les ids.
     ---------------------------------------------------------- */
  var TRIPTYQUES = [
    {
      id: 'passage-des-arches',
      nom: 'Le Passage des Arches',
      soustitre: 'Terracotta — 3 panneaux',
      format: '50×70cm',
      bundleProduitId: 16452569006425,
      bundleHandle: 'le-passage-des-arches-triptyque-mural-3-panneaux-terracotta-mediterraneen',
      bundlePrix: { 'Poster': 159, 'Encadrée': 299 },
      bundleVariantes: { 'Poster': 58699097866585, 'Encadrée': 58699098521945 },
      panneaux: [
        { produitId: 16448914653529, variantes: { 'Poster': 58674833490265, 'Encadrée': 58676834861401 } },
        { produitId: 16449280803161, variantes: { 'Poster': 58677647671641, 'Encadrée': 58679316906329 } },
        { produitId: 16449286668633, variantes: { 'Poster': 58677716844889, 'Encadrée': 58679316545881 } }
      ]
    }
  ];

  /* ---------------------- utilitaires ----------------------- */

  function lireJSON(zone, cle) {
    try { return JSON.parse(zone.getItem(cle) || 'null'); } catch (e) { return null; }
  }

  function ecrireJSON(zone, cle, valeur) {
    try {
      if (valeur === null) zone.removeItem(cle);
      else zone.setItem(cle, JSON.stringify(valeur));
    } catch (e) { /* stockage indisponible : on dégrade en silence */ }
  }

  function lireActif() { return lireJSON(window.localStorage, CLE_ACTIF); }
  function ecrireActif(v) { ecrireJSON(window.localStorage, CLE_ACTIF, v); }
  function lireEtat() { return lireJSON(window.localStorage, CLE_ETAT); }
  function ecrireEtat(v) { ecrireJSON(window.localStorage, CLE_ETAT, v); }

  function trouverTriptyque(id) {
    for (var i = 0; i < TRIPTYQUES.length; i++) {
      if (TRIPTYQUES[i].id === id) return TRIPTYQUES[i];
    }
    return null;
  }

  function estBundle(produit) {
    if (!produit) return false;
    for (var i = 0; i < TRIPTYQUES.length; i++) {
      if (Number(produit.id) === TRIPTYQUES[i].bundleProduitId) return true;
      if (produit.handle && produit.handle === TRIPTYQUES[i].bundleHandle) return true;
    }
    return false;
  }

  function prixFR(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  /* ==========================================================
     Correctif de fetch — installé avant l'exécution de gwb.js
     ========================================================== */

  var fetchOrigine = window.fetch;

  function substituerPanier(corps) {
    var actif = lireActif();
    if (!actif) return null;
    var t = trouverTriptyque(actif.id);
    if (!t) return null;
    var variante = t.bundleVariantes[actif.finition];
    if (!variante) return null;

    var charge;
    try { charge = typeof corps === 'string' ? JSON.parse(corps) : null; }
    catch (e) { return null; }
    if (!charge || !charge.items || !charge.items.length) return null;

    /* Garde-fou : substitution seulement si le panier correspond
       exactement aux trois panneaux, dans la bonne finition. Sinon
       on laisse passer les lignes individuelles au prix individuel. */
    var attendus = [];
    for (var i = 0; i < t.panneaux.length; i++) {
      attendus.push(Number(t.panneaux[i].variantes[actif.finition]));
    }
    if (charge.items.length !== attendus.length) return null;
    for (var j = 0; j < charge.items.length; j++) {
      if (attendus.indexOf(Number(charge.items[j].id)) === -1) return null;
      if (Number(charge.items[j].quantity || 1) !== 1) return null;
    }

    return JSON.stringify({ items: [{ id: variante, quantity: 1 }] });
  }

  function filtrerProduits(reponse) {
    return reponse.clone().json().then(function (donnees) {
      if (!donnees || !donnees.products || !donnees.products.length) return reponse;
      var avant = donnees.products.length;
      var gardes = [];
      for (var i = 0; i < donnees.products.length; i++) {
        if (!estBundle(donnees.products[i])) gardes.push(donnees.products[i]);
      }
      if (gardes.length === avant) return reponse;
      donnees.products = gardes;
      return new Response(JSON.stringify(donnees), {
        status: reponse.status,
        statusText: reponse.statusText,
        headers: { 'Content-Type': 'application/json' }
      });
    })['catch'](function () { return reponse; });
  }

  window.fetch = function (entree, options) {
    var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
    var opts = options;

    if (url.indexOf('/cart/add.js') !== -1 && opts && opts.body) {
      var remplacement = substituerPanier(opts.body);
      if (remplacement) {
        var copie = {};
        for (var k in opts) {
          if (Object.prototype.hasOwnProperty.call(opts, k)) copie[k] = opts[k];
        }
        copie.body = remplacement;
        opts = copie;
      }
    }

    var promesse = fetchOrigine.call(this, entree, opts);
    if (url.indexOf('products.json') !== -1) return promesse.then(filtrerProduits);
    return promesse;
  };

  /* ==========================================================
     Application d'un triptyque
     ========================================================== */

  function appliquer(t, finition, essai) {
    essai = essai || 0;
    var etat = lireEtat();

    /* Au premier passage l'état n'existe pas : on laisse gwb.js
       créer lui-même les trois emplacements, puis on réessaie. On
       ne fabrique jamais les ids d'emplacement — ils lui appartiennent. */
    if (!etat || !etat.slots || etat.slots.length < 3) {
      if (essai > 8) return;
      var bouton3 = document.querySelector('.gwb__count[data-count="3"]');
      if (bouton3) bouton3.click();
      setTimeout(function () { appliquer(t, finition, essai + 1); }, 250);
      return;
    }

    etat.count = 3;
    etat.activePreset = 'symetrique';
    etat.spacingMode = 'equilibre';
    etat.customPhoto = { enabled: false };

    var slots = etat.slots.slice(0, 3);
    for (var i = 0; i < 3; i++) {
      slots[i].productId = t.panneaux[i].produitId;
      slots[i].variantId = t.panneaux[i].variantes[finition];
      slots[i].format = t.format;
      slots[i].finish = finition;
      slots[i].locked = false;
    }
    etat.slots = slots;
    etat.activeSlotId = slots[0].id;

    ecrireEtat(etat);
    ecrireActif({ id: t.id, finition: finition });
    try { window.sessionStorage.setItem(CLE_ATTENTE, '1'); } catch (e) {}
    window.location.reload();
  }

  function retirer() {
    ecrireActif(null);
    deverrouiller();
    majTiroir();
  }

  /* ==========================================================
     Verrouillage des pastilles, correction du total
     ========================================================== */

  function pastilles() {
    return document.querySelectorAll('[data-pill-option="format"], [data-pill-option="finish"]');
  }

  function verrouiller() {
    var p = pastilles();
    for (var i = 0; i < p.length; i++) {
      p[i].setAttribute('aria-disabled', 'true');
      p[i].setAttribute('title', 'Format et finition imposés par le triptyque');
      p[i].style.opacity = '.4';
      p[i].style.pointerEvents = 'none';
    }
  }

  function deverrouiller() {
    var p = pastilles();
    for (var i = 0; i < p.length; i++) {
      p[i].removeAttribute('aria-disabled');
      p[i].removeAttribute('title');
      p[i].style.opacity = '';
      p[i].style.pointerEvents = '';
    }
  }

  /* Auto-guérison : si l'état ne correspond plus au triptyque
     annoncé (le client a changé une affiche), on relâche tout.

     ATTENTION : au chargement, gwb.js réécrit l'état AVANT d'avoir
     reçu products.json, donc productId vaut null pendant un instant.
     Un emplacement à null n'est PAS une incohérence, c'est une
     hydratation en cours. Conclure trop tôt désactive le triptyque
     au rechargement et le verrou ne s'applique jamais. */
  function verifierCoherence() {
    var actif = lireActif();
    if (!actif) return false;
    var t = trouverTriptyque(actif.id);
    if (!t) { retirer(); return false; }
    var etat = lireEtat();
    if (!etat || !etat.slots || etat.slots.length !== 3) return true;
    for (var i = 0; i < 3; i++) {
      var pid = etat.slots[i].productId;
      if (pid === null || typeof pid === 'undefined') continue;
      if (Number(pid) !== t.panneaux[i].produitId) { retirer(); return false; }
    }
    return true;
  }

  function majTotal() {
    var cible = document.getElementById('gwb-total-price');
    if (!cible) return;
    var actif = lireActif();
    if (!actif) return;
    var t = trouverTriptyque(actif.id);
    if (!t) return;
    var bundle = t.bundlePrix[actif.finition];
    if (!bundle) return;
    var individuel = 0;
    var m = (cible.textContent || '').replace(/\s/g, '').match(/([\d.,]+)€/);
    if (m) individuel = parseFloat(m[1].replace(',', '.')) || 0;
    var texte = 'Total : ' + prixFR(bundle) + ' — triptyque';
    if (individuel > bundle) texte += ' (au lieu de ' + prixFR(individuel) + ')';
    if (cible.textContent !== texte) cible.textContent = texte;
  }

  /* ==========================================================
     Ajustement des cadres dans la scène

     L'emplacement prend le ratio du FORMAT (50/70 = 0,714) mais le
     visuel encadré a le ratio du CADRE (1313/1922 = 0,683), plus
     haut. gwb.css applique object-fit:cover, qui remplit la largeur
     et rogne 2,3 % en haut et en bas — la baguette du cadre y passe.

     Passer en contain règle le rognage mais peint l'affiche 4,4 %
     trop étroite, avec du vide de part et d'autre : les cadres
     paraissent maigres et les écarts du triptyque se creusent.

     La bonne réponse est d'agrandir la boîte, pas de rétrécir
     l'image. Un tirage encadré est physiquement plus grand que
     l'affiche nue : le cadre déborde. On étire donc le conteneur
     de 2,3 % en haut et en bas, l'affiche reprend toute la largeur
     de son emplacement et le cadre reste entier.

     Le taux se calcule par emplacement : il dépend du ratio de
     l'image ET du format choisi. En 61 × 91 cm par exemple le
     rapport s'inverse et c'est la largeur qu'il faut étirer. Un
     pourcentage figé en CSS serait faux dès le premier changement
     de taille — d'où le calcul en JS.
     ========================================================== */

  function ecouterImage(img) {
    if (!img || img.getAttribute('data-cadre-ecoute')) return;
    img.setAttribute('data-cadre-ecoute', '1');
    img.addEventListener('load', function () { ajusterCadres(); });
  }

  function ajusterCadres() {
    var slots = document.querySelectorAll('#gwb-stage-overlay .gwb__frame-slot');
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      var inner = s.querySelector('.gwb__frame-slot-inner');
      var img = s.querySelector('.gwb__frame-slot-image');
      if (!inner) continue;
      ecouterImage(img);

      var haut = '', bas = '', gauche = '', droite = '';

      if (s.className.indexOf('is-framed') !== -1 && img && img.naturalWidth) {
        var rect = s.getBoundingClientRect();
        if (rect.width && rect.height) {
          var boite = rect.width / rect.height;
          var image = img.naturalWidth / img.naturalHeight;
          if (image < boite - 0.0005) {
            var m = ((boite / image) - 1) / 2 * 100;
            haut = bas = (-m) + '%';
          } else if (image > boite + 0.0005) {
            var n = ((image / boite) - 1) / 2 * 100;
            gauche = droite = (-n) + '%';
          }
        }
      }

      /* On n'écrit que si la valeur change : l'observateur de
         l'overlay surveille aussi l'attribut style, une écriture
         systématique le relancerait en boucle. */
      if (inner.style.top !== haut) inner.style.top = haut;
      if (inner.style.bottom !== bas) inner.style.bottom = bas;
      if (inner.style.left !== gauche) inner.style.left = gauche;
      if (inner.style.right !== droite) inner.style.right = droite;
    }
  }

  /* ==========================================================
     Interface — tiroir « Triptyque »
     ========================================================== */

  function construireTiroir() {
    var bloc = document.querySelector('.gwb__preset-block');
    if (!bloc || document.getElementById('gwb-triptyque-drawer')) return;

    var lignes = [];
    for (var i = 0; i < TRIPTYQUES.length; i++) {
      var t = TRIPTYQUES[i];
      lignes.push(
        '<div class="gwb-triptyque__item">' +
          '<div class="gwb-triptyque__nom">' + t.nom +
            '<span class="gwb-triptyque__soustitre">' + t.soustitre + ' · ' + t.format + '</span>' +
          '</div>' +
          '<div class="gwb__preset-list">' +
            '<button type="button" class="gwb__preset" data-triptyque="' + t.id + '" data-finition="Poster">Poster ' + prixFR(t.bundlePrix['Poster']) + '</button>' +
            '<button type="button" class="gwb__preset" data-triptyque="' + t.id + '" data-finition="Encadrée">Encadrée ' + prixFR(t.bundlePrix['Encadrée']) + '</button>' +
          '</div>' +
        '</div>'
      );
    }

    /* Pas d'attribut data-drawer : le script inline du template
       synchronise [data-drawer-value] avec le .is-active du tiroir,
       ce qui écraserait notre libellé. On garde la classe pour le
       style, on lui retire la prise. */
    var d = document.createElement('details');
    d.className = 'gwb__drawer';
    d.id = 'gwb-triptyque-drawer';
    d.innerHTML =
      '<summary class="gwb__drawer-summary">' +
        '<span class="gwb__drawer-text">' +
          '<span class="gwb__drawer-label">Triptyque</span>' +
          '<span class="gwb__drawer-value" data-drawer-value></span>' +
        '</span>' +
        '<span class="gwb__drawer-chevron" aria-hidden="true"></span>' +
      '</summary>' +
      '<div class="gwb__drawer-body">' +
        lignes.join('') +
        '<button type="button" id="gwb-triptyque-retirer" class="gwb__reset-btn" hidden>Revenir à la composition libre</button>' +
      '</div>';

    bloc.insertBefore(d, bloc.firstChild);

    d.addEventListener('click', function (evt) {
      var b = evt.target.closest ? evt.target.closest('[data-triptyque]') : null;
      if (b) {
        evt.preventDefault();
        var t = trouverTriptyque(b.getAttribute('data-triptyque'));
        if (t) appliquer(t, b.getAttribute('data-finition'));
        return;
      }
      if (evt.target.id === 'gwb-triptyque-retirer') {
        evt.preventDefault();
        retirer();
      }
    });

    var style = document.createElement('style');
    style.textContent =
      '#gwb-triptyque-drawer .gwb-triptyque__item + .gwb-triptyque__item{margin-top:10px;padding-top:10px;border-top:1px solid rgba(61,53,48,.08)}' +
      '#gwb-triptyque-drawer .gwb-triptyque__nom{display:flex;flex-direction:column;gap:1px;font-size:12px;font-weight:600;margin-bottom:6px}' +
      '#gwb-triptyque-drawer .gwb-triptyque__soustitre{font-size:11px;font-weight:400;opacity:.65}' +
      '#gwb-triptyque-drawer .gwb__preset.is-active{font-weight:700}' +
      /* Débordement des cartes d'emplacement. Bug préexistant de
         gwb.css : le contenu d'une carte occupe 373 px alors que la
         colonne de grille en fait 257 dès qu'il y a trois affiches.
         À rapatrier dans gwb.css lors d'une prochaine passe. */
      '#gallery-wall-builder .gwb__slot-card,#gallery-wall-builder .gwb__slot-card *{min-width:0!important}' +
      '#gallery-wall-builder .gwb__slot-card>*,#gallery-wall-builder .gwb__slot-card-head>*{max-width:100%!important}' +
      '#gallery-wall-builder .gwb__slot-actions-row{flex-wrap:wrap}' +
      '#gallery-wall-builder .gwb__pill-group{flex-wrap:wrap}' +
      '#gallery-wall-builder .gwb__slot-card-meta{overflow:hidden;text-overflow:ellipsis}' +
      /* Filet de sécurité : si le calcul d'ajusterCadres() n'a pas
         encore tourné (image pas chargée), contain évite au moins
         que le cadre soit rogné. Une fois la boîte ajustée au ratio
         de l'image, contain et cover donnent le même résultat. */
      '#gallery-wall-builder .gwb__frame-slot.is-framed .gwb__frame-slot-image{object-fit:contain}';
    document.head.appendChild(style);
  }

  function majTiroir() {
    var d = document.getElementById('gwb-triptyque-drawer');
    if (!d) return;
    var actif = lireActif();

    var boutons = d.querySelectorAll('[data-triptyque]');
    for (var i = 0; i < boutons.length; i++) {
      var correspond = !!actif &&
        boutons[i].getAttribute('data-triptyque') === actif.id &&
        boutons[i].getAttribute('data-finition') === actif.finition;
      if (correspond) boutons[i].classList.add('is-active');
      else boutons[i].classList.remove('is-active');
    }

    var retirerBtn = document.getElementById('gwb-triptyque-retirer');
    if (retirerBtn) retirerBtn.hidden = !actif;

    var valeur = d.querySelector('[data-drawer-value]');
    if (valeur) {
      if (actif) {
        var t = trouverTriptyque(actif.id);
        valeur.textContent = t ? t.nom + ' · ' + actif.finition : '';
      } else {
        valeur.textContent = 'Aucun';
      }
    }
  }

  /* ==========================================================
     Amorçage
     ========================================================== */

  function apresRechargement() {
    var enAttente = false;
    try {
      enAttente = window.sessionStorage.getItem(CLE_ATTENTE) === '1';
      window.sessionStorage.removeItem(CLE_ATTENTE);
    } catch (e) {}
    if (!enAttente || !lireActif()) return;

    /* On laisse gwb.js finir d'hydrater les produits, puis on lui
       fait recalculer la mise en page avec ses propres boutons —
       plutôt que de fabriquer des coordonnées à sa place. */
    setTimeout(function () {
      var sym = document.querySelector('.gwb__preset[data-preset="symetrique"]');
      if (sym) sym.click();
      var centrer = document.getElementById('gwb-center-composition');
      if (centrer) centrer.click();
      if (verifierCoherence()) verrouiller();
      majTiroir();
      majTotal();
      ajusterCadres();
      var scene = document.querySelector('.gwb__stage-wrap');
      if (scene && scene.scrollIntoView) {
        scene.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 900);
  }

  function surveiller() {
    window.addEventListener('resize', ajusterCadres);
    if (typeof MutationObserver !== 'function') return;
    var cible = document.getElementById('gwb-slot-controls');
    var total = document.getElementById('gwb-total-price');
    var overlay = document.getElementById('gwb-stage-overlay');

    if (overlay) {
      new MutationObserver(function () { ajusterCadres(); }).observe(overlay, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ['style', 'class', 'src']
      });
    }
    if (cible) {
      new MutationObserver(function () {
        if (verifierCoherence()) verrouiller();
        majTiroir();
      }).observe(cible, { childList: true, subtree: true });
    }
    if (total) {
      new MutationObserver(function () {
        if (total.getAttribute('data-triptyque-en-cours')) return;
        total.setAttribute('data-triptyque-en-cours', '1');
        majTotal();
        total.removeAttribute('data-triptyque-en-cours');
      }).observe(total, { childList: true, characterData: true, subtree: true });
    }
  }

  function init() {
    if (!document.getElementById('gallery-wall-builder')) return;
    construireTiroir();
    if (verifierCoherence()) verrouiller();
    majTiroir();
    majTotal();
    ajusterCadres();
    surveiller();
    apresRechargement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
